export const dexfApiKeys = {
    pax: '5bf70f96-11aa-4773-a4dd-f67330b651ee',
    besta: '86f2d515-3a76-4195-bdab-60d072c42336',
    platsa: '4d059903-e6cc-4c12-be6a-eb33693057e0',
    eket: '79961114-8ac4-4cbc-9a8b-9faa71c2fb48',
    smastad: '0ec63d26-ddc8-496e-a13e-3fee6338379e',
    ivar: '978146f3-3069-4176-a945-460c494b7a84',
    billy: 'fec13e30-148b-441d-967a-5be851f923b1',
    bror: '5620b5c4-98b7-41c2-a8b5-765b0fd5fa96',
    kallax: 'cdb6dd5c-ec98-4e0e-8160-966dae6fa398',
    boaxel: 'a56392c3-013d-4dc0-b5a7-85618b1d9dc0',
    ladmakare: '0c872a7d-62ee-4dc8-8bfc-916ec6c41c47',
    lastare: '29a42c9c-5f07-47bd-aabb-79bae7a09357',
    jonaxel: '717e7bf3-0190-46d1-bbc5-2208a3f9880c',
    elvarli: '094b01b5-b441-4ed2-9142-1d84d47f8949',
    knoxhult: '1b805f40-e99e-4f26-87e7-a3f035abf0eb',
    aurdal: '58982793-fbae-488f-bf08-a8de3897b4c9',
    metod: 'a4e8f4f9-3847-4c93-8387-4bb61cc48ac3',
    trofast: '41cd8913-c5fb-46ae-a5a2-41420f3035ca'
};
export const dexfQaApiKeys = {
    pax: '5aa59f8b-1738-4dc6-b410-365d72724d8a',
    besta: 'd7533a0b-a25c-4db2-b847-091d2996fd85',
    platsa: '642e7ab7-9c19-4d04-83c1-84fe467d7960',
    eket: 'b33209d9-9a84-48f1-a8bf-6f03caa58bcc',
    smastad: '5cffedce-9f16-442c-817b-7caa5f7d01a5',
    ivar: '4f1442ac-1c0c-44f9-891e-26ca719d8e6f',
    billy: 'f0c72f73-52bc-4cdf-b828-6193b5a6c723',
    bror: 'c17afb12-3281-4456-9bda-eec11f5c6326',
    kallax: 'd84eb171-3a41-4dfa-b251-d0f2af829cbd',
    boaxel: '51420759-765d-4031-877a-a4d6a7b8b35a',
    ladmakare: 'f46ed05f-cbef-447b-abd0-28c9661ea154',
    lastare: '92591660-b2be-4b00-b582-f8f8a0814ffc',
    jonaxel: '0cec2ab7-a663-4dd3-a773-7d7681348a95',
    elvarli: '829e294e-1e25-4f81-975e-ad53ac4a3682',
    knoxhult: '8bff9343-76eb-4064-877f-8a9cb8b17a72',
    aurdal: 'cc2330dc-6329-45a2-8ae3-ce02f6efaa22',
    metod: 'e154aa8d-7691-42bb-8b59-07177a683249',
    trofast: 'addc5fc0-fad5-45ea-b566-2b43b0978947'
};
const getDexfApiKeyQa = (range) => {
    switch (range) {
        case 'pax':
            return dexfQaApiKeys.pax;
        case 'platsa':
            return dexfQaApiKeys.platsa;
        case 'besta':
            return dexfQaApiKeys.besta;
        case 'eket':
            return dexfQaApiKeys.eket;
        case 'smastad':
            return dexfQaApiKeys.smastad;
        case 'ivar':
            return dexfQaApiKeys.ivar;
        case 'billy':
            return dexfQaApiKeys.billy;
        case 'bror':
            return dexfQaApiKeys.bror;
        case 'kallax':
            return dexfQaApiKeys.kallax;
        case 'boaxel':
            return dexfQaApiKeys.boaxel;
        case 'ladmakare':
            return dexfQaApiKeys.ladmakare;
        case 'lastare':
            return dexfQaApiKeys.lastare;
        case 'jonaxel':
            return dexfQaApiKeys.jonaxel;
        case 'elvarli':
            return dexfQaApiKeys.elvarli;
        case 'knoxhult':
            return dexfQaApiKeys.knoxhult;
        case 'aurdal':
            return dexfQaApiKeys.aurdal;
        case 'metod':
            return dexfQaApiKeys.metod;
        case 'trofast':
            return dexfQaApiKeys.trofast;
        default:
            throw new Error('Unknown range.');
    }
};
const getDexfApiKeyProd = (range) => {
    switch (range) {
        case 'besta':
            return dexfApiKeys.besta;
        case 'platsa':
            return dexfApiKeys.platsa;
        case 'pax':
            return dexfApiKeys.pax;
        case 'eket':
            return dexfApiKeys.eket;
        case 'smastad':
            return dexfApiKeys.smastad;
        case 'ivar':
            return dexfApiKeys.ivar;
        case 'billy':
            return dexfApiKeys.billy;
        case 'bror':
            return dexfApiKeys.bror;
        case 'kallax':
            return dexfApiKeys.kallax;
        case 'boaxel':
            return dexfApiKeys.boaxel;
        case 'ladmakare':
            return dexfApiKeys.ladmakare;
        case 'lastare':
            return dexfApiKeys.lastare;
        case 'jonaxel':
            return dexfApiKeys.jonaxel;
        case 'elvarli':
            return dexfApiKeys.elvarli;
        case 'knoxhult':
            return dexfApiKeys.knoxhult;
        case 'aurdal':
            return dexfApiKeys.aurdal;
        case 'metod':
            return dexfApiKeys.metod;
        case 'trofast':
            return dexfApiKeys.trofast;
        default:
            throw new Error('Unknown range.');
    }
};
export const getDexfApiKey = (range, qa = false) => {
    return qa ? getDexfApiKeyQa(range) : getDexfApiKeyProd(range);
};
//# sourceMappingURL=dexfApiKey.js.map